/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Plus_FooterInputs */

const en_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus Smarter with Plus.`)
};

const ar_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ارتقى بتركيزك، بلس أذكى`)
};

const de_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klüger fokussieren mit Plus.`)
};

const es_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejora tu concentración, Plus es más inteligente`)
};

const fr_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentrez-vous plus intelligemment avec Plus.`)
};

const it_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliora la tua concentrazione`)
};

const ja_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中力を高めるなら、Plusで賢くアップグレード`)
};

const ko_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업그레이드된 집중력, 스마트한 Plus`)
};

const pt_br_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eleve o nível do seu foco, seja Plus`)
};

const ru_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Улучшите свою сосредоточенность!`)
};

const th_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเกรดการโฟกัสของคุณ ให้ฉลาดขึ้นด้วย Plus`)
};

const tr_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus ile Daha Akıllıca Odaklan.`)
};

const zh_cn_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注升级，Plus 更聪明`)
};

const zh_tw_daily_paywall_plus_footer = /** @type {(inputs: Daily_Paywall_Plus_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注升級，Plus 更聰明`)
};

/**
* | output |
* | --- |
* | "Focus Smarter with Plus." |
*
* @param {Daily_Paywall_Plus_FooterInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_plus_footer = /** @type {((inputs?: Daily_Paywall_Plus_FooterInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Plus_FooterInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_plus_footer(inputs)
	if (locale === "ar") return ar_daily_paywall_plus_footer(inputs)
	if (locale === "de") return de_daily_paywall_plus_footer(inputs)
	if (locale === "es") return es_daily_paywall_plus_footer(inputs)
	if (locale === "fr") return fr_daily_paywall_plus_footer(inputs)
	if (locale === "it") return it_daily_paywall_plus_footer(inputs)
	if (locale === "ja") return ja_daily_paywall_plus_footer(inputs)
	if (locale === "ko") return ko_daily_paywall_plus_footer(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_plus_footer(inputs)
	if (locale === "ru") return ru_daily_paywall_plus_footer(inputs)
	if (locale === "th") return th_daily_paywall_plus_footer(inputs)
	if (locale === "tr") return tr_daily_paywall_plus_footer(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_plus_footer(inputs)
	return zh_tw_daily_paywall_plus_footer(inputs)
});